import api from "shared/api";
import { BaseApiService } from "shared/api";
import { withToast } from "shared/utils";

class CostLinesService extends BaseApiService {
  async deleteCostLine(id) {
    return await withToast(() =>
      api.delete(`${this.ENDPOINTS.cost_line.entity}/${id}`)
    );
  }
  async updateCostLine(payload) {
    return await withToast(
      () => api.post(this.ENDPOINTS.cost_line.update, payload),
      {
        catchError: true,
      }
    );
  }
  async storeCostLine(payload) {
    return await withToast(
      () => api.post(this.ENDPOINTS.cost_line.entity, payload),
      {
        catchError: true,
      }
    );
  }
  async acceptCostLine(payload) {
    return await withToast(() =>
      api.post(this.ENDPOINTS.cost_line.accept, payload)
    );
  }
  async rejectCostLine(payload) {
    return await withToast(() =>
      api.post(this.ENDPOINTS.cost_line.reject, payload)
    ).then((response) => response.data.data);
  }
}

export default new CostLinesService();
